// HomeScreen.styles.tsx
import { styled } from '@mui/system'
import Box from '@mui/material/Box'
import AppBar from '@mui/material/AppBar'

export const ScreenBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  position: 'relative'
})

export const ButtonBox = styled(Box)({
  position: 'absolute',
  top: '10px',
  right: '10px'
})

export const CustomAppBar = styled(AppBar)({
  backgroundColor: '#2196F3', // You can use your desired color
  width: '100%',
  zIndex: 1
})

export const LogoBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
})
